
export function preventDefault(e) {
    e.preventDefault?.();
    e.nativeEvent?.preventDefault?.();
}

export function stopPropagation(e) {
    e.stopPropagation?.();
    e.stopImmediatePropagation?.();
    e.nativeEvent?.stopPropagation?.();
    e.nativeEvent?.stopImmediatePropagation?.();
}
